import { render, staticRenderFns } from "./TSMHome.vue?vue&type=template&id=18bef31e&"
import script from "./TSMHome.vue?vue&type=script&lang=js&"
export * from "./TSMHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports